import styles from "../../pages/Community/CreateCommunityPage.module.css";

const VideosList = ({
  currentVideos,
  isSubmitting,
  handleEditVideo,
  handleDeleteVideo,
  handleMoveVideoUp,
  handleMoveVideoDown,
}) => {
  return (
    <div className={styles.sectionList}>
      {currentVideos.map((video, index) => (
        <div key={index} className={styles.sectionRow}>
          <div className={styles.reorderButtons}>
            <button
              className={styles.arrowButton}
              onClick={() => handleMoveVideoUp(index)}
              disabled={index === 0 || isSubmitting}
              title="Move up"
            >
              ▲
            </button>
            <button
              className={styles.arrowButton}
              onClick={() => handleMoveVideoDown(index)}
              disabled={index === currentVideos.length - 1 || isSubmitting}
              title="Move down"
            >
              ▼
            </button>
          </div>

          <span className={styles.sectionLabel}>
            {video.title || "Untitled Video"}
          </span>

          <div className={styles.sectionActions}>
            <button
              className={styles.editIconButton}
              onClick={() => handleEditVideo(index)}
              disabled={isSubmitting}
            >
              ✎
            </button>
            <button
              className={styles.deleteIconButton}
              onClick={() => handleDeleteVideo(index)}
              disabled={isSubmitting}
            >
              🗑
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VideosList;
